import { waitForPageLoadAnalytics } from "./pageLoad";
import { getCommons, getGlobalEvars } from "./common";
import { getCommonLooksTrackingValues } from "./looks/common";
import { getCommonRecommendedOutfitsTrackingValues } from "./recommendedOutfits/common";
import getWindow from "../utils/window";
import { clearEvents, setEvents, setLinkTrackEvents } from "./events";
import { getCustomerIsAuthenticated } from "../utils/identity";

export const BACK_IN_STOCK_NOTIFY_ME_CLICK_TRACKING_NAME =
  "backInStockNotifyMeClick";

export default async function fireNotifyMeClickAnalytics(
  selectedVariantId,
  pageArea,
  products
) {
  await waitForPageLoadAnalytics;

  const s = getWindow().s;
  const trackVars = ["prop31"];
  const isAuthenticated = await getCustomerIsAuthenticated();
  let overrides = {
    prop31: isAuthenticated ? "logged in" : "anonymous",
  };

  clearEvents({ trackingName: BACK_IN_STOCK_NOTIFY_ME_CLICK_TRACKING_NAME });
  setEvents({
    events: ["event214"],
    trackingName: BACK_IN_STOCK_NOTIFY_ME_CLICK_TRACKING_NAME,
  });
  s.products = `;${selectedVariantId}`;

  if (pageArea === "looks") {
    const commonLooksTracking = getCommonLooksTrackingValues({
      products,
    });

    overrides = {
      ...overrides,
      ...commonLooksTracking,
    };

    trackVars.push(...Object.keys(commonLooksTracking));
  }

  if (pageArea === "recommendedoutfits") {
    const commonRecommendedOutfitsTracking =
      getCommonRecommendedOutfitsTrackingValues(products);

    overrides = {
      ...overrides,
      ...commonRecommendedOutfitsTracking,
    };

    trackVars.push(...Object.keys(commonRecommendedOutfitsTracking));
  }

  overrides = {
    ...overrides,
    linkTrackEvents: setLinkTrackEvents({
      trackingName: BACK_IN_STOCK_NOTIFY_ME_CLICK_TRACKING_NAME,
    }),
    linkTrackVars: getCommons().setLinkTrackVars([
      ...getGlobalEvars(),
      ...trackVars,
    ]),
  };

  s.tl(true, "o", "back in stock - notify me", overrides);
}

export async function fireBackInStockSuccessAnalytics(selectedVariantId) {
  await waitForPageLoadAnalytics;

  const s = getWindow().s;
  const isAuthenticated = await getCustomerIsAuthenticated();

  clearEvents({ trackingName: BACK_IN_STOCK_NOTIFY_ME_CLICK_TRACKING_NAME });
  setEvents({
    events: ["event366", "event172"],
    trackingName: BACK_IN_STOCK_NOTIFY_ME_CLICK_TRACKING_NAME,
  });
  s.products = `;${selectedVariantId}`;

  const overrides = {
    prop31: isAuthenticated ? "logged in" : "anonymous",
    eVar106: "back in stock|notification|subscribe",
    linkTrackEvents: setLinkTrackEvents({
      trackingName: BACK_IN_STOCK_NOTIFY_ME_CLICK_TRACKING_NAME,
    }),
    linkTrackVars: getCommons().setLinkTrackVars([
      ...getGlobalEvars(),
      "prop31",
      "eVar106",
    ]),
  };

  s.tl(
    true,
    "o",
    "back in stock notification - successful subscription",
    overrides
  );
}
